import React from 'react'
import PropTypes from 'prop-types'
import { DragLayer } from 'react-dnd'

import ImagesDragPreview from './ImagesDragPreview'

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
}

const getItemStyles = currentOffset => {
  if (!currentOffset) {
    return {
      display: 'none',
    }
  }

  const { x, y } = currentOffset

  return {
    transform: `translate(${x}px, ${y}px)`,
    filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.45))',
  }
}

const collect = monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
})

class ImageDragLayer extends React.Component {
  render() {
    if (!this.props.isDragging || !this.props.item.imagesDragStack) {
      return null
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props.currentOffset)}>
          <ImagesDragPreview
            images={this.props.item.imagesDragStack}
            imageProps={this.props.imageProps}
            imageComponent={this.props.imageComponent}
          />
        </div>
      </div>
    )
  }
}

ImageDragLayer.propTypes = {
  item: PropTypes.object,
  imageComponent: PropTypes.func.isRequired,
  initialOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  isDragging: PropTypes.bool.isRequired,
  imageProps: PropTypes.object,
}

export default DragLayer(collect)(ImageDragLayer)
